module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head",
      "type": "file",
      "accept": "image/*",
      "capture": "camera"
    },
    on: {
      "change": function($event) {
        return _vm.setImagePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("拍照")])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload-item"
  }, [_c('a', {
    staticClass: "file file2",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "id": "file_head2",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.setFilePreview()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("文件")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02048b34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/H5Upload.vue
// module id = 1642
// module chunks = 471